import React, { FC } from "react";
import styled from "styled-components";
import { graphql, Link, useStaticQuery } from "gatsby";
import Img from "gatsby-image";

import { mediaQuery } from "src/themes/breakpoints";
import { colors } from "src/themes/colors";

const Wrapper = styled.div`
  align-items: center;
  background-color: ${colors.blue};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px 20px 30px;
`;

const ImgWraper = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  width: 140px;
`;
const Navigation = styled.nav`
  display: grid;
  grid-column-gap: 30px;
  grid-row-gap: 10px;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;

  ${mediaQuery("md")} {
    grid-column-gap: 60px;
    grid-template-columns: repeat(4, 1fr);
  }
`;

const StyledLink = styled(Link)`
  color: ${colors.grey100};
  font-size: 14px;
  font-weight: 700;
  position: relative;
  text-align: center;

  &:after {
    background: none repeat scroll 0 0 transparent;
    background-color: ${colors.grey100};
    bottom: 0;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }

  &:hover:after {
    width: 100%;
  }

  ${mediaQuery("md")} {
    font-size: 16px;
  }
`;

const Footer: FC = () => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo-grey.png" }) {
        childImageSharp {
          fluid(maxWidth: 280, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <ImgWraper>
        <Img fluid={data.logo.childImageSharp.fluid} alt="Eimantas Gulbinas" />
      </ImgWraper>
      <Navigation role="secondary">
        <StyledLink to="/about-us">Über Uns</StyledLink>
        <StyledLink to="/contacts">Kontakt</StyledLink>
        <StyledLink to="/impressum">Impressum</StyledLink>
        <StyledLink to="/data-protection">Datenschutz</StyledLink>
      </Navigation>
    </Wrapper>
  );
};

export default Footer;
